module.exports = "<p>\n  request-property-app-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/request-properties/request-property-approval/request-property-app-form/request-property-app-form.component.html
// module id = ./src/app/recovery/request-properties/request-property-approval/request-property-app-form/request-property-app-form.component.html
// module chunks = main